export default "__VITE_ASSET__cBn5sngy__"